<template>
    <form class="g pop-up-inner" :style="styleSet">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || '輸入提示'"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <div class="md" v-html="content.html"></div>
                    <div class="md">
                        <div class="cp input select" :class="[errors.has('value')? 'is-error': '']" :data-error="errors.first('value')">
                            <select v-model="value" v-validate="content.validate" name="value">
                                <option v-if="showNull" value="">{{ nullText }}</option>
                                <option
                                    v-for="item in option"
                                    :key="item.value" :value="item.value">{{ item.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </form>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdBtnList from '@/components/mdBtnList'

    import { mapMutations } from 'vuex'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){
            let $styleSet = {};

            let _width = this.content.width;

            if( _width && typeof _width === 'number' ) {
                $styleSet.width = _width +'px';
            }else if( _width && typeof _width === 'string') {
                $styleSet.width = _width;
            }else {
                $styleSet.width = 'auto';
            }

            return {
                value: '',
                option: [],
                styleSet: $styleSet
            }
        },
        watch: {
            value: {
                handler: function(){
                    let $content = this.content,
                        _customizable = $content.customizable;

                    let _value = this.value,
                        _msg = this.$t('site.status.customMsg');

                    if( _customizable && _value === _msg ) {
                        this.addOption();
                    }
                }
            }
        },
        computed: {
            showNull: function(){
                let $content = this.content,
                    _showNull = $content.showNull;

                if( _showNull === false ) {
                    return false;
                }else {
                    return true;
                }
            },
            nullText: function(){
                let $content = this.content,
                    _nullText = $content.nullText;

                if( _nullText ) {
                    return _nullText;
                }else {
                    return '請選擇';
                }
            },
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: $content.cancelName || this.$t('site.func.popupclose'),
                        icon: $content.cancelIcon || '',
                        themes: $content.cancelTheme || '',
                        func: 'close',
                    }

                let $results = [].concat($moreBtns);

                $results.push($action);
                $results.push($cancel);

                return $results;
            },
        },
        methods: {
            ...mapMutations([
                'pushPopUp',
                'alert',
                'tra'
            ]),
            sendFuncEvent: function(func){ //多 btn 功能

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {
                        let $content = this.content,
                            _value = this.value;

                        $content[func](_value);
                    }
                });
            },
            action: function(){

                this.$validator.validate().then(result => {
                    if (!result){
                        //啊就沒通過啊
                    }else {
                        let $content = this.content,
                            $_action = $content.action,
                            _value = this.value;

                        if( $content.actionStopClose !== true ) {
                            this.close();
                        }

                        $_action(_value);
                    }
                });
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
            addOption: function() {
                let _customMsgCaption = this.$t('site.status.customMsgCaption'),
                    _customMsgHtml = this.$t('site.status.customMsgHtml')

                let $_addOption = (val) => {

                        let $option = this.option,
                            _length = $option.length - 1;

                        $option.splice(_length, 0, {
                            value: val,
                            name: val
                        });

                        this.$set(this, 'value', val);
                    }

                this.pushPopUp({
                    type: 'prompt',
                    content: {
                        caption: _customMsgCaption,
                        html: _customMsgHtml,
                        validate: 'required',
                        action: $_addOption
                    }
                });
            },
            setValue: function(){
                let $content = this.content,
                    _value = $content.value;

                if( _value ) {
                    this.$set(this, 'value', _value);
                }
            },
            setData: function(){
                let $content = this.content,
                    $options = $content.options; //可以是 Object 也可以是 Array

                let $result = [];

                if( Array.isArray($options) ) {

                    $options.forEach(item => {

                        $result.push({
                            value: item,
                            name: item
                        });
                    });

                }else if( typeof $options === 'object' ) {

                    for( let _key in $options ) {
                        let _name = $options[_key];

                        $result.push({
                            value: _key,
                            name: _name
                        });
                    }
                }

                if( $content.customizable ) {
                    let _msg = this.$t('site.status.customMsg'),
                        $target = $result.find(item => {
                            return item.name === _msg;
                        });

                    if( $target === undefined ) {

                        $result.push({
                            value: _msg,
                            name: _msg
                        });
                    }
                }

                this.$set(this, 'option', $result);
            }
        },
        created: function(){
            this.setData();
            this.setValue();
        }
    }
</script>

<style scoped lang="scss">

    .pop-up-content {

        .md {

            + .md {
                margin-top: 6px;
            }
        }
    }

    .input {
        width: 100%;
    }
</style>
